import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import debounce from 'lodash.debounce'
import { PATH as ORIG_PATH } from 'constants/urls'
import {
  Container,
  Content,
  Toggle,
  LogoWrapper,
  HelpHeader,
  Hamburger,
  Actions,
  IconLink,
  TextLink,
  ButtonLink,
} from './index.style'
import Logo from './Logo'
import PaperAirplane from './PaperAirplane'

const Header = ({ isStyledHeader, baseUrl, isHelp }) => {
  const { t } = useTranslation('general')
  const PATH = ORIG_PATH(baseUrl)

  const [scrollToTop, setScrollToTop] = useState(true)

  useEffect(() => {
    const handleScroll = debounce(() => {
      const halfHeight = window.innerHeight / 2
      const top =
        (document.documentElement && document.documentElement.scrollTop) ||
        document.body.scrollTop
      setScrollToTop(top < halfHeight)
    }, 10)

    window.addEventListener('scroll', handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  const NAV_ITEMS = [
    {
      key: 'Header.Course List',
      url: PATH.COURSES,
    },
    {
      key: 'Header.Latest News',
      url: PATH.LATEST_NEWS,
    },
    {
      key: 'Header.Download App',
      url: PATH.DOWNLOAD_APP,
    },
    {
      key: 'Header.Help Center',
      url: PATH.HELP_CENTER,
    },
    {
      key: 'Header.Features',
      url: PATH.ABOUT_PRODUCT,
    },
  ]

  return (
    <Container showStyledHeader={isStyledHeader && scrollToTop}>
      <Content>
        {!isHelp && <Toggle />}
        <LogoWrapper>
          <a href={isHelp ? PATH.HELP_CENTER : PATH.HOME_PAGE}>
            <Logo />
            {isHelp && (
              <>
                <HelpHeader.Title>
                  {t('Header.Help Center Title')}
                </HelpHeader.Title>
                <HelpHeader.Logo />
              </>
            )}
          </a>
        </LogoWrapper>
        {!isHelp && (
          <>
            <Hamburger>
              <span />
            </Hamburger>
            <Actions>
              <IconLink to={PATH.HOME_PAGE}>
                <PaperAirplane />
                <span>{t('Header.Enter PaCode or Course Code')}</span>
              </IconLink>
              {NAV_ITEMS.map(({ key, url }) => (
                <TextLink key={key} to={url}>
                  <span>{t(key)}</span>
                </TextLink>
              ))}
              <ButtonLink to={PATH.SIGN_UP}>
                <span>{t('Header.Get Started')}</span>
              </ButtonLink>
            </Actions>
          </>
        )}
      </Content>
    </Container>
  )
}

Header.propTypes = {
  isStyledHeader: PropTypes.bool,
  baseUrl: PropTypes.string,
  isHelp: PropTypes.bool,
}

export default Header
